import React from 'react'
import PropTypes from 'prop-types'
import Tabs from 'components/common/Tabs'
import YMMEPlate from '../YmmePlate'
import ShopByTires from '../ShopByTires'
import { Wrapper } from '../SharedStyles'

const menu = [{ title: 'Shop by Vehicle' }, { title: 'Shop by Tire Size' }]

const YMMEComponent = ({ handleShopByTireSizesSubmit, ...props }) =>
  <Wrapper>
    <Tabs ymme menu={ menu }>
      <YMMEPlate { ...props } shopByTiresIndex={ 1 } />
      <ShopByTires handleShopByTireSizesSubmit={ handleShopByTireSizesSubmit } />
    </Tabs>
  </Wrapper>

YMMEComponent.propTypes = {
  handleShopByTireSizesSubmit: PropTypes.func
}

export default YMMEComponent
